import { PartnerRelationLevel, PartnerStatus, PartnerType } from "types/partner";

export const PARTNER_PATH = "/partner";

export const partnerTypeOptions: { label: string; value: PartnerType }[] = [
  { label: "Cá nhân", value: "PERSON" },
  { label: "Công ty", value: "COMPANY" },
  { label: "Hiệp hội", value: "ASSOCIATION" },
];

export const partnerRelationOptions: { label: string; value: PartnerRelationLevel; color: string }[] = [
  { label: "Thân thiết", value: "CLOSE", color: "green" },
  { label: "Bình thường", value: "NORMAL", color: "blue" },
  { label: "Mới", value: "NEW", color: "orange" },
];

export const partnerStatusOptions: { label: string; value: PartnerStatus; color: string }[] = [
  { label: "Đang hợp tác", value: "ACTIVE", color: "green" },
  { label: "Tạm dừng", value: "PAUSED", color: "default" },
];

export const getPartnerTypeLabel = (value?: string) =>
  partnerTypeOptions.find((option) => option.value === value)?.label || "--";

export const getPartnerRelation = (value?: string) => partnerRelationOptions.find((option) => option.value === value);

export const getPartnerStatus = (value?: string) => partnerStatusOptions.find((option) => option.value === value);
